import { useEffect } from "react";

import { usePlayer } from "@/components/player";
import { useAuth } from "@/providers";

import { useIsExternalPage } from "./useIsExternalPage";

export const useClearStory = () => {
  const isExternalPage = useIsExternalPage();
  const { stop } = usePlayer();
  const { user } = useAuth();

  useEffect(() => {
    if (!user && isExternalPage) {
      stop();
    }
    // eslint-disable-next-line
  }, [isExternalPage]);
};
